import {styled} from "@mui/material/styles";
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import * as font from "../utilities/fontUtilities";
import * as tag from "../constants/customMetadataConstants";
import * as portalShared from "../shared/metadataConstantsAndUtilities"


// export function setColor(iObj, metadataTag, defaultColor) {
//
//     let color = defaultColor;
//
//     color = tag.metadataValue(iObj, metadataTag, "", color); // In case of override
//
//     return color;
// }


// export function setTextColor(iObj, metadataTag, textObj) {
//
//     let color = textObj.colorType === "select" ? textObj.color : textObj.colorEntry;
//
//     color = tag.metadataValue(iObj, metadataTag, "", color); // In case of override
//
//     return color;
// }


export function getColor(answer, selected, colorObj) {

    let color = colorObj.unselectedColor;

    if (answer.id === selected.id) {
        color = colorObj.selectedColor;
    }

    return color;
}


// export function getOutlinedOverrides(question, textObj) {
//
//     let outlinedOverrides = {
//
//         textObj: textObj.fontObj,
//
//         height: tag.metadataValue(question, portalShared.BUTTON_HEIGHT, "", portalShared.DEFAULT_BUTTON_HEIGHT),
//
//         widthOverride: tag.metadataValue(question, portalShared.OVERRIDE_WIDTH, "", "250px"),
//
//         unselectedTextColor: portalShared.COLOR_BLACK_HEX,
//         unselectedBorderColor:  portalShared.COLOR_BLACK_HEX,
//         unselectedBackgroundColor:  portalShared.COLOR_BLACK_HEX,
//
//         selectedTextColor:  portalShared.COLOR_BLACK_HEX,
//         selectedBorderColor:  portalShared.COLOR_BLACK_HEX,
//         selectedBackgroundColor:  portalShared.COLOR_BLACK_HEX,
//
//         // unselectedTextColor: tag.metadataValue(question, portalShared.UNSELECTED_COLOR_TEXT, "", textObj.fontObj.color),
//         // unselectedBorderColor: tag.metadataValue(question, portalShared.UNSELECTED_COLOR_BORDER, "", portalShared.DEFAULT_UNSELECTED_BUTTON_BORDER_COLOR),
//         // unselectedBackgroundColor: tag.metadataValue(question, portalShared.UNSELECTED_COLOR_BACKGROUND, "", portalShared.COLOR_WHITE_HEX),
//         //
//         // selectedTextColor: tag.metadataValue(question, portalShared.SELECTED_COLOR_TEXT, "", portalShared.DEFAULT_SELECTED_BUTTON_TEXT_COLOR),
//         // selectedBorderColor: tag.metadataValue(question, portalShared.SELECTED_COLOR_BORDER, "", portalShared.DEFAULT_SELECTED_BUTTON_BORDER_COLOR),
//         // selectedBackgroundColor: tag.metadataValue(question, portalShared.SELECTED_COLOR_BACKGROUND, "", portalShared.DEFAULT_SELECTED_BUTTON_BACKGROUND_COLOR),
//
//         borderWidth: parseInt(tag.metadataValue(question, portalShared.BUTTON_BORDER_WIDTH, "", "1px")),
//         borderRadius: parseInt(tag.metadataValue(question, portalShared.BUTTON_BORDER_RADIUS, "", "10px")),
//     }
//
//     outlinedOverrides.hoverTextColor = portalShared.COLOR_BLACK_HEX;
//     outlinedOverrides.hoverBorderColor = portalShared.COLOR_BLACK_HEX;
//     outlinedOverrides.hoverBackgroundColor = portalShared.COLOR_BLACK_HEX;
//
//     outlinedOverrides.hoverSelectedTextColor = portalShared.COLOR_BLACK_HEX;
//     outlinedOverrides.hoverSelectedBorderColor = portalShared.COLOR_BLACK_HEX;
//     outlinedOverrides.hoverSelectedBackgroundColor = portalShared.COLOR_BLACK_HEX;
//
//     // outlinedOverrides.hoverTextColor = tag.metadataValue(question, portalShared.HOVER_COLOR_TEXT, "", outlinedOverrides.unselectedTextColor);
//     // outlinedOverrides.hoverBorderColor = tag.metadataValue(question, portalShared.HOVER_COLOR_BORDER, "", outlinedOverrides.unselectedBorderColor);
//     // outlinedOverrides.hoverBackgroundColor = tag.metadataValue(question, portalShared.HOVER_COLOR_BACKGROUND, "", outlinedOverrides.unselectedBackgroundColor);
//     //
//     // outlinedOverrides.hoverSelectedTextColor = tag.metadataValue(question, portalShared.HOVER_SELECTED_COLOR_TEXT, "", outlinedOverrides.selectedTextColor);
//     // outlinedOverrides.hoverSelectedBorderColor = tag.metadataValue(question, portalShared.HOVER_SELECTED_COLOR_BORDER, "", outlinedOverrides.selectedBorderColor);
//     // outlinedOverrides.hoverSelectedBackgroundColor = tag.metadataValue(question, portalShared.HOVER_SELECTED_COLOR_BACKGROUND, "", outlinedOverrides.selectedBackgroundColor);
//
//     return outlinedOverrides;
// }
//
// export function getStyledFormControlLabel(outlinedOverrides, selected, readonly) {
//
//     return styled(FormControlLabel)({
//         root: {
//             marginBottom: '10px',
//             width: outlinedOverrides.widthOverride,
//             border: 'solid',
//             borderWidth: outlinedOverrides.borderWidth,
//             borderRadius: outlinedOverrides.borderRadius,
//             borderColor: selected ? outlinedOverrides.selectedBorderColor : outlinedOverrides.unselectedBorderColor,
//             //height: buttonOverrides.height,
//             disableRipple: readonly,
//             disableFocusRipple: readonly,
//
//             // textTransform: "none",
//             // fontFamily: outlinedOverrides.textObj.fontFamily,
//             // fontWeight: outlinedOverrides.textObj.fontWeight,
//             // fontSize: outlinedOverrides.textObj.fontSize,
//             // fontStyle: outlinedOverrides.textObj.fontWeight,
//             // color: selected ? outlinedOverrides.selectedTextColor : outlinedOverrides.unselectedTextColor,
//
//             backgroundColor: selected ? outlinedOverrides.selectedBackgroundColor : outlinedOverrides.unselectedBackgroundColor,
//             "&:hover": {
//                 border: 'solid',
//                 borderWidth: outlinedOverrides.borderWidth,
//                 borderRadius: outlinedOverrides.borderRadius,
//                 borderColor: selected ? outlinedOverrides.hoverSelectedBorderColor : outlinedOverrides.hoverBorderColor,
//                 color: selected ? outlinedOverrides.hoverSelectedTextColor : outlinedOverrides.hoverTextColor,
//                 backgroundColor: selected ? outlinedOverrides.hoverSelectedBackgroundColor : outlinedOverrides.hoverBackgroundColor,
//             },
//
//         }
//     });
//
// }


export function getOutlinedRadioStyle(outlinedMode, answer, savedObjs) {

    let formStyle = {}; // If not outlined mode then standard radios need no extra styling

    if (outlinedMode) {

        // If any input type other than radio there must be a custom question object, so we can get default colors from there.

        let customQuestionObj = savedObjs.customTemplateObj; // NULL if no custom question object

        let selected = (savedObjs.selectedAnswer.id === answer.id);

        let borderColorObj = {
            color: selected ? portalShared.getColor(customQuestionObj.selectedBorder) : portalShared.getColor(customQuestionObj.unselectedBorder),
            hoverColor: selected ? portalShared.getColor(customQuestionObj.hoverBorder) : portalShared.getColor(customQuestionObj.hoverSelectedBorder),
        }

        let bgColorObj = {
            color: selected ? portalShared.getColor(customQuestionObj.selectedBackground) : portalShared.getColor(customQuestionObj.unselectedBackground),
            hoverColor: selected ? portalShared.getColor(customQuestionObj.hoverSelectedBackground) : portalShared.getColor(customQuestionObj.hoverBackground),
        }

        // borderColorObj.unselectedColor = setColor(savedObjs.question, portalShared.UNSELECTED_COLOR_BORDER, borderColorObj.unselectedColor);
        // borderColorObj.selectedColor = setColor(savedObjs.question, portalShared.SELECTED_COLOR_BORDER, borderColorObj.selectedColor);
        //
        // bgColorObj.unselectedColor = setColor(savedObjs.question, portalShared.UNSELECTED_COLOR_BACKGROUND, bgColorObj.unselectedColor);
        // bgColorObj.selectedColor = setColor(savedObjs.question, portalShared.SELECTED_COLOR_BACKGROUND, bgColorObj.selectedColor);

        formStyle = {
            width: savedObjs.customTemplateObj.width === "100%" ? savedObjs.customTemplateObj.buttonWidth : savedObjs.customTemplateObj.width,
            border: 'solid',
            borderRadius: '10px',
            borderWidth: '1px',
            borderColor: borderColorObj.color,
            backgroundColor: bgColorObj.color,
            marginBottom: '10px',
            "&:hover": {backgroundColor: bgColorObj.hoverColor, borderColor: borderColorObj.hoverColor}
        };
    }

    return formStyle;
}

// ---------------------------------------------------------------------------------------------------------------------
// Get Custom Radio/Outlined Radio Style
// ---------------------------------------------------------------------------------------------------------------------
export function getRadioStyle(savedObjs, standardRadio = false) {

    // NOTE: THis function is used by standard radios and outlined radios

    let customQuestionObj = savedObjs.customTemplateObj; // NULL if no custom question object

    //let defaultUnselectedControlColor = standardRadio ? portalShared.DEFAULT_UNSELECTED_RADIO_CONTROL_COLOR : portalShared.DEFAULT_UNSELECTED_OUTLINED_RADIO_CONTROL_COLOR;
    //let defaultSelectedControlColor = standardRadio ? portalShared.DEFAULT_SELECTED_RADIO_CONTROL_COLOR : portalShared.DEFAULT_SELECTED_OUTLINED_RADIO_CONTROL_COLOR;

    // let unselectedColorControl = tag.metadataValue(savedObjs.activeTemplate, portalShared.UNSELECTED_COLOR_CONTROL, "", defaultUnselectedControlColor);
    //
    // let selectedColorControl = tag.metadataValue(savedObjs.activeTemplate, portalShared.SELECTED_COLOR_CONTROL, "", defaultSelectedControlColor);
    //
    // let hoverColorControl = tag.metadataValue(savedObjs.activeTemplate, portalShared.HOVER_COLOR_CONTROL, "", portalShared.DEFAULT_HOVER_RADIO_CONTROL_COLOR);

    // If not standard radio it is an outlined radio
    let unselectedControl = portalShared.COLOR_GRAY_HEX;
    let selectedControl = standardRadio ? portalShared.COLOR_DEFAULT_BLUE_HEX : portalShared.COLOR_WHITE_HEX;
    let hoverControl = standardRadio ? portalShared.COLOR_DEFAULT_BLUE_HEX : portalShared.COLOR_WHITE_HEX;

    if (!standardRadio) {
        unselectedControl = portalShared.COLOR_GRAY_HEX;
        selectedControl = standardRadio ? portalShared.COLOR_DEFAULT_BLUE_HEX : portalShared.COLOR_WHITE_HEX;
        hoverControl = standardRadio ? portalShared.COLOR_DEFAULT_BLUE_HEX : portalShared.COLOR_WHITE_HEX;
    }

    //let selectedFlag = (answer.id === savedObjs.selectedAnswer.id);

    if (customQuestionObj !== null && customQuestionObj.color === "custom") {

        unselectedControl = portalShared.getColor(customQuestionObj.unselectedControl);
        selectedControl = portalShared.getColor(customQuestionObj.selectedControl);
        hoverControl = portalShared.getColor(customQuestionObj.hoverControl);
    }

    const StyledRadio = styled(Radio)({
        color: unselectedControl,
        disableRipple: savedObjs.readonlyMode,
        disableFocusRipple: savedObjs.readonlyMode,
        disableTouchRipple: savedObjs.readonlyMode,
        '&.Mui-checked': {
            color: selectedControl,
            disableRipple: savedObjs.readonlyMode,
            disableFocusRipple: savedObjs.readonlyMode,
            disableTouchRipple: savedObjs.readonlyMode,
        },
        "&:hover": {
            color: hoverControl,  // Control color
            borderColor: "green"
            //border: 'solid',
            //borderColor: 'red', // touch border color don't seem to work
            //background: "green", // touch interior color don't seem to work
        }
    });

    return StyledRadio;
}


// ---------------------------------------------------------------------------------------------------------------------
// Get Custom DDLB Style
// ---------------------------------------------------------------------------------------------------------------------
// export function getDdlbStyle(savedObjs) {
//
//     let selectedColorControl = tag.metadataValue(savedObjs.activeTemplate, portalShared.SELECTED_COLOR_CONTROL, "" , portalShared.COLOR_DEFAULT_BLUE_HEX);
//     let unselectedColorControl = tag.metadataValue(savedObjs.activeTemplate, portalShared.UNSELECTED_COLOR_CONTROL, "" , portalShared.DEFAULT_UNSELECTED_COLOR);
//
//     const StyledRadio = withStyles({
//         root: {
//             color: unselectedColorControl,
//             disableRipple: savedObjs.readonlyMode,
//             disableFocusRipple: savedObjs.readonlyMode,
//             disableTouchRipple: savedObjs.readonlyMode,
//             '&$checked': {
//                 color: selectedColorControl,
//                 disableRipple: savedObjs.readonlyMode,
//                 disableFocusRipple: savedObjs.readonlyMode,
//                 disableTouchRipple: savedObjs.readonlyMode,
//             },
//         },
//         checked: {},
//     })(Radio);
//
//     return StyledRadio;
// }


// ---------------------------------------------------------------------------------------------------------------------
// Get Custom Button
// ---------------------------------------------------------------------------------------------------------------------

// let buttonOverrides = {
//     customTemplateObj: tag.metadataValue(savedObjs.question, portalShared.CUSTOM_DDO_QUE_FORMAT),

//     unselectedTextColor: tag.metadataValue(savedObjs.question, portalShared.UNSELECTED_COLOR_TEXT, "", portalShared.DEFAULT_UNSELECTED_BUTTON_TEXT_COLOR),
//     unselectedBorderColor: tag.metadataValue(savedObjs.question, portalShared.UNSELECTED_COLOR_BORDER, "", portalShared.DEFAULT_UNSELECTED_BUTTON_BORDER_COLOR),
//     unselectedBackgroundColor: tag.metadataValue(savedObjs.question, portalShared.UNSELECTED_COLOR_BACKGROUND, "", portalShared.DEFAULT_UNSELECTED_BUTTON_BACKGROUND_COLOR),

//     selectedTextColor: tag.metadataValue(savedObjs.question, portalShared.SELECTED_COLOR_TEXT, "", portalShared.DEFAULT_SELECTED_BUTTON_TEXT_COLOR),
//     selectedBorderColor: tag.metadataValue(savedObjs.question, portalShared.SELECTED_COLOR_BORDER, "", portalShared.DEFAULT_SELECTED_BUTTON_BORDER_COLOR),
//     selectedBackgroundColor: tag.metadataValue(savedObjs.question, portalShared.SELECTED_COLOR_BACKGROUND, "", portalShared.DEFAULT_SELECTED_BUTTON_BACKGROUND_COLOR),

//     hoverTextColor: tag.metadataValue(savedObjs.question, portalShared.HOVER_COLOR_TEXT, "", portalShared.DEFAULT_HOVER_BUTTON_TEXT_COLOR),
//     hoverBorderColor: tag.metadataValue(savedObjs.question, portalShared.HOVER_COLOR_BORDER, "", portalShared.DEFAULT_HOVER_BUTTON_BORDER_COLOR),
//     hoverBackgroundColor: tag.metadataValue(savedObjs.question, portalShared.SELECTED_COLOR_BACKGROUND, "", portalShared.DEFAULT_HOVER_BUTTON_BACKGROUND_COLOR),

//     borderWidth: tag.metadataValue(savedObjs.question, portalShared.SELECTED_COLOR_BACKGROUND, "", portalShared.DEFAULT_BUTTON_BORDER_WIDTH),
//     borderRadius: tag.metadataValue(savedObjs.question, portalShared.SELECTED_COLOR_BACKGROUND, "", portalShared.DEFAULT_BUTTON_BORDER_RADIUS),
// }

export function getButtonStyle(buttonType, savedObjs, buttonOverrides, selected) {

    //let outlinedButton = (buttonType === ssType.SINGLE_SELECT_CLEAR_BUTTON); // force push

    let style = styled(Button)({
        width: buttonOverrides.widthOverride,
        border: 'solid',
        borderWidth: buttonOverrides.borderWidth,
        borderRadius: buttonOverrides.borderRadius,
        borderColor: selected ? buttonOverrides.selectedBorderColor : buttonOverrides.unselectedBorderColor,
        boxShadow: buttonOverrides.boxShadowOverride,
        height: buttonOverrides.height,
        padding: '0px',
        disableRipple: savedObjs.readonlyMode,
        disableFocusRipple: savedObjs.readonlyMode,
        fullWidth: true,
        opacity: "100%",
        textTransform: "none",
        fontFamily: buttonOverrides.textObj.fontFamily,
        fontWeight: "normal",
        fontSize: buttonOverrides.textObj.fontSize,  // 2em, 18pt
        fontStyle: "normal",
        color: selected ? buttonOverrides.selectedTextColor : buttonOverrides.unselectedTextColor,
        backgroundColor: selected ? buttonOverrides.selectedBackgroundColor : buttonOverrides.unselectedBackgroundColor,
        "&:hover": {
            border: 'solid',
            borderWidth: buttonOverrides.borderHoverWidth,
            borderRadius: buttonOverrides.borderHoverRadius,
            borderColor: selected ? buttonOverrides.hoverSelectedBorderColor : buttonOverrides.hoverBorderColor,
            fontWeight: "bold",
            color: selected ? buttonOverrides.hoverSelectedTextColor : buttonOverrides.hoverTextColor,
            backgroundColor: selected ? buttonOverrides.hoverSelectedBackgroundColor : buttonOverrides.hoverBackgroundColor,
            // '& .MuiButton-label': {
            //     color: "#fff" NOT TESTED
            //     }
        }
    });

    return style;
}

// export function getCheckboxStyle(buttonType, savedObjs, buttonOverrides, selected) {
//
//     //let outlinedButton = (buttonType === ssType.SINGLE_SELECT_CLEAR_BUTTON);
//
//     let style = withStyles({
//         root: {
//             width: buttonOverrides.widthOverride,
//             border: 'solid',
//             borderWidth: buttonOverrides.borderWidth,
//             borderRadius: buttonOverrides.borderRadius,
//             borderColor: selected ? buttonOverrides.selectedBorderColor : buttonOverrides.unselectedBorderColor,
//             boxShadow: buttonOverrides.boxShadowOverride,
//             height: buttonOverrides.height,
//             padding: '0px',
//             disableRipple: savedObjs.readonlyMode,
//             disableFocusRipple: savedObjs.readonlyMode,
//             fullWidth: true,
//             opacity: "100%",
//             textTransform: "none",
//             fontFamily: buttonOverrides.textObj.fontFamily,
//             fontWeight: "normal",
//             fontSize: buttonOverrides.textObj.fontSize,  // 2em, 18pt
//             fontStyle: "normal",
//             color: selected ? buttonOverrides.selectedTextColor : buttonOverrides.unselectedTextColor,
//             backgroundColor: selected ? buttonOverrides.selectedBackgroundColor : buttonOverrides.unselectedBackgroundColor,
//             '&:hover': {
//                 border: 'solid',
//                 borderWidth: buttonOverrides.borderWidth,
//                 borderRadius: buttonOverrides.borderRadius,
//                 borderColor: selected ? buttonOverrides.hoverSelectedBorderColor : buttonOverrides.hoverBorderColor,
//                 fontWeight: "bold",
//                 color: selected ? buttonOverrides.hoverSelectedTextColor : buttonOverrides.hoverTextColor,
//                 backgroundColor: selected ? buttonOverrides.hoverSelectedBackgroundColor : buttonOverrides.hoverBackgroundColor,
//                 // '& .MuiButton-label': {
//                 //     color: "#fff" NOT TESTED
//                 //     }
//             },
//
//         }
//     })(Checkbox);
//
//     return style;
// }

// ---------------------------------------------------------------------------------------------------------------------
// Get Custom Title Typography
// ---------------------------------------------------------------------------------------------------------------------
// export function getTitleLabelTextStyle(activeTemplate, surveyEditMode) {
//
//     let surveyEditModeFlag = (surveyEditMode === portalShared.READONLY_SURVEY)
//
//     let selectedColorControl = tag.metadataValue(activeTemplate, portalShared.SELECTED_COLOR_CONTROL, "" , "white");
//     let unselectedColorControl = tag.metadataValue(activeTemplate, portalShared.UNSELECTED_COLOR_CONTROL, "" , "grey");
//
//     const StyledRadio = withStyles({
//         root: {
//             color: unselectedColorControl,
//             disableRipple: surveyEditModeFlag,
//             disableFocusRipple: surveyEditModeFlag,
//             disableTouchRipple: surveyEditModeFlag,
//             '&$checked': {
//                 color: selectedColorControl,
//                 disableRipple: surveyEditModeFlag,
//                 disableFocusRipple: surveyEditModeFlag,
//                 disableTouchRipple: surveyEditModeFlag,
//             },
//         },
//         checked: {},
//     })(Radio);
//
//     return StyledRadio;
// }


// ---------------------------------------------------------------------------------------------------------------------
// Get Custom Title Typography
// ---------------------------------------------------------------------------------------------------------------------
// export function getQuestionTextStyle(activeTemplate, surveyEditMode) {
//
//     let surveyEditModeFlag = (surveyEditMode === portalShared.READONLY_SURVEY)
//
//     let selectedColorControl = tag.metadataValue(activeTemplate, portalShared.SELECTED_COLOR_CONTROL, "" , "white");
//     let unselectedColorControl = tag.metadataValue(activeTemplate, portalShared.UNSELECTED_COLOR_CONTROL, "" , "grey");
//
//     const StyledRadio = withStyles({
//         root: {
//             color: unselectedColorControl,
//             disableRipple: surveyEditModeFlag,
//             disableFocusRipple: surveyEditModeFlag,
//             disableTouchRipple: surveyEditModeFlag,
//             '&$checked': {
//                 color: selectedColorControl,
//                 disableRipple: surveyEditModeFlag,
//                 disableFocusRipple: surveyEditModeFlag,
//                 disableTouchRipple: surveyEditModeFlag,
//             },
//         },
//         checked: {},
//     })(Radio);
//
//     return StyledRadio;
// }

// ---------------------------------------------------------------------------------------------------------------------
// Get Custom Title Typography
// ---------------------------------------------------------------------------------------------------------------------
// export function getCustomTitleTypography(iObj, metadataTag, alignPosition) {
//
//     let tempCustomTypography = null;
//     let useCustom = false;
//     let customTextObj = "";
//
//     if (tag.metadataExists(iObj, metadataTag)) {
//         customTextObj = tag.metadataValue(iObj, metadataTag);
//
//         if (typeof customObj !== "string") {
//             useCustom = true;
//             tempCustomTypography = getCustomTextStyle(customTextObj, "", alignPosition);
//         }
//     }
//
//     return {"customTypography": tempCustomTypography, "useCustom": useCustom, "name": customTextObj.title, customTextObj: customTextObj};
// }

// ---------------------------------------------------------------------------------------------------------------------
// Get Custom Responsive label Typography
// ---------------------------------------------------------------------------------------------------------------------
// export function getResponsiveLabelTextStyle(activeTemplate, surveyEditMode) {
//
//     let surveyEditModeFlag = (surveyEditMode === portalShared.READONLY_SURVEY)
//
//     let selectedColorControl = tag.metadataValue(activeTemplate, portalShared.SELECTED_COLOR_CONTROL, "" , "white");
//     let unselectedColorControl = tag.metadataValue(activeTemplate, portalShared.UNSELECTED_COLOR_CONTROL, "" , "grey");
//
//     const StyledRadio = withStyles({
//         root: {
//             color: unselectedColorControl,
//             disableRipple: surveyEditModeFlag,
//             disableFocusRipple: surveyEditModeFlag,
//             disableTouchRipple: surveyEditModeFlag,
//             '&$checked': {
//                 color: selectedColorControl,
//                 disableRipple: surveyEditModeFlag,
//                 disableFocusRipple: surveyEditModeFlag,
//                 disableTouchRipple: surveyEditModeFlag,
//             },
//         },
//         checked: {},
//     })(Radio);
//
//     return StyledRadio;
// }


// ---------------------------------------------------------------------------------------------------------------------
// Default Typography Display
// ---------------------------------------------------------------------------------------------------------------------
export function getCustomTextStyle(customTextObj, hoverColor = "") {

    let tempFontSize = "12pt"
    let includesFontSize = false;
    if (customTextObj?.fontSize) includesFontSize = customTextObj?.fontSize.includes("pt")
    if (customTextObj?.fontSize)
    if ((customTextObj?.fontSize !== "caption") && includesFontSize) {
        tempFontSize = customTextObj?.fontSize;
    }
    else {
        tempFontSize = font.convertVariantToPointsStr(customTextObj?.fontSize);
    }

    let tempCustomTypography;

    let tempObj;

    tempObj = customTextObj;
    tempCustomTypography = styled(Typography)({
        //float: alignPosition,
        //paddingLeft: tempObj.indent !== "" ? tempObj.indent : "0px",
        font: tempObj?.fontFamily ?? font.DEFAULT_FONT_FAMILY,
        fontFamily: tempObj?.fontFamily ?? font.DEFAULT_FONT_FAMILY,
        fontWeight: tempObj?.fontWeight ?? "normal",
        color:tempObj?.colorObj?.colorType === "select" ? tempObj?.colorObj?.color : tempObj?.colorObj?.colorEntry ?? "black",
        fontSize: tempObj?.fontSize ?? tempFontSize,  // 2em, 18pt
        fontStyle: tempObj?.fontStyle ??"normal",
        textAlign: tempObj?.textAlign ?? "left",  // left center right
        opacity: tempObj?.colorObj?.opacity ?? "100%",
        // marginBottom: likertIndex !== 0 && rightAndAlignedWithQuestions ? '20px' : '0px'

        "&:hover": {
            color: hoverColor,  // Define a hover color, or fallback to blue
            // cursor: "text"
        }
    });

    return tempCustomTypography;
}



